export default "__VITE_PUBLIC_ASSET__eb441e75__"